import React from 'react';
import '../Styles/NewsStyle.css';

function Disclaimer() {
    return (
        <div>
            <section className='footerSubPages'>
                <p data-aos="fade-up"
                    data-aos-duration="2000" className='caSubHead'>Disclaimer</p>
                <p data-aos="fade-up"
                    data-aos-duration="2000" className='ca_para'>If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at blues@mahindra.com
<br></br>
                    <br></br>
                    All the information on this website is published in good faith and for general information purposes only. Any action you take upon the information you find on this website (www.mahindrablues.com ), is strictly at your own risk. www.mahindrablues.com will not be liable for any losses and/or damages in connection with the use of our website.
                    <br></br>
                    <br></br>
                    From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'. Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
                    <br></br>
                    <br></br>
                    <span className='headSub'>Consent </span>
                    <br></br>
                    By using our website, you hereby consent to our disclaimer and agree to its terms.
                    <br></br>
                    <br></br>
                    <span className='headSub'>Update</span>
                    <br></br>
                    This site disclaimer was last updated on: Friday, December 28th, 2012. Should we update, amend or make any changes to this document, those changes will be prominently posted here</p>
            </section>
        </div>
    )
}

export default Disclaimer